import { render } from "./PostsTable.vue?vue&type=template&id=2a190c59"
import script from "./PostsTable.vue?vue&type=script&lang=js"
export * from "./PostsTable.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__